
import { IFieldForm } from "pages/read-documents/model/IFieldForm";

export const fieldsFormUser = (): IFieldForm[]  => {
    return [
        {
            id: 'itemFormproviderCode',
            name: 'code',
            type: 'text',
            label: 'Código de proveedor',
            placeholder: 'Código de prestador',
            testId: 'itemFormproviderCode',
            isEnable: true
        },
        {
            id: 'itemformNit',
            name: 'employerIdNumber',
            type: 'text',
            label: 'Nit de prestador',
            placeholder: 'Ingrese nit',
            testId: 'itemformNit',
            isEnable: true
        },
        {
            id: 'itemformProviderName',
            name: 'name',
            type: 'text',
            label: 'Nombre de prestador',
            placeholder: 'Ingrese nombre',
            testId: 'itemformProviderName',
            isEnable: true
        },
    ]
}